
import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';

import './poc.css'

const POC = (props) => (
    <React.Fragment>
        <div>
            <p>POC Component</p>
        </div>
        <div class="resp-container">
            <iframe src="https://pwa-kimclark-com-dev-ncus.azurewebsites.net/en/activity-finder?mode=iframe" class="resp-iframe"></iframe>
        </div>
        <div>
            <p>POC Footer</p>
        </div>
    </React.Fragment>
);

export default POC;
